import React from "react";
import TableViewForm from "./TableViewForm";
import { Paper, withStyles, Grid } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/tableViewActions";
import History from "../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const TableViewSystemCreate = props => {
    const { classes, activeCustomerID, translations, permissions, onCreateTableView } = props;

    const handleSubmit = async data => {
        let result = await onCreateTableView({ ...data, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: "",
        QueryType: "",
        Parameters: '',
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            QueryType: Yup.string().required("Required"),
            Parameters: Yup.string().required("Required"),
        },
        FormTitle: translations["create_table_view"] || "Create Table View",
        ButtonSubmit: hasPermission(permissions, "table_view_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <Paper className={classes.root}>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    <TableViewForm
                        classes={classes}
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        translations={translations}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateTableView: params => dispatch(actions.createTableView(params))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TableViewSystemCreate));